module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "alp-home"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('img', {
    staticClass: "alp-home__icon",
    attrs: {
      "src": require("./assets/arrow.down.png"),
      "alt": "arrow down",
      "height": "24",
      "width": "24"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "alp-home__themes"
  }, _vm._l((_vm.themes), function(theme) {
    return _c('alp-big-theme', {
      key: "theme.slug",
      attrs: {
        "link": _vm.getLink(theme),
        "image": theme.slug
      }
    }, [_vm._v(_vm._s(theme.title))])
  })), _vm._v(" "), _c('div', {
    staticClass: "alp-home__footer"
  }, [_vm._v("\n    Site à l'initiative de citoyens insoumis.\n  ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "alp-home__title"
  }, [_vm._v("\n    Analysons le projet du "), _c('span', {
    staticClass: "alp-home__title__red"
  }, [_vm._v("Front National")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "alp-home__intro"
  }, [_vm._v("\n    Les rapprochements et amalgames entre le programme de la France Insoumise et celui du Front National ont été très nombreux et très virulents. Pourtant, "), _c('strong', [_vm._v("aucune analyse sérieuse et critique des propositions de Marine Le Pen")]), _vm._v(" n'a été vraiment réalisée pour tenter de les confronter à celles portées par Jean-Luc Mélenchon.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n    Le Discord Insoumis propose donc une analyse des propositions du Front National à travers plusieurs thèmes. Cette analyse est bien évidemment très critique car le projet de société de Marine Le Pen est non seulement à l'opposé de celui de la France Insoumise mais il présente de nombreuses incohérences.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n    Ce site a pour objectif d'être "), _c('strong', [_vm._v("une source de réflexion")]), _vm._v(" pour favoriser l'esprit critique de la population autour du projet mortifère du Front National. C'est un espace en développement permanent qui sera enrichi au fil des prochaines semaines.\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "alp-home__choose"
  }, [_vm._v("\n    Sélectionnez un thème pour analyser le projet du\n    "), _c('span', {
    staticClass: "alp-home__intro__red"
  }, [_vm._v("Front National")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b573032"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Home.vue
// module id = 180
// module chunks = 0